import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Header from '../../components/ui/Header';
import RegistrationForm from './components/RegistrationForm';
import PricingInfo from './components/PricingInfo';
import TrustSignals from './components/TrustSignals';
import OAuthOptions from './components/OAuthOptions';

const EmployerRegistration = () => {
  useEffect(() => {
    document.title = 'Employer Registration - Workfolio';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="container mx-auto px-6 lg:px-8 py-12">
        {/* Header Section */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-primary/10 rounded-2xl mb-6">
            <Icon name="Building2" size={40} className="text-primary" />
          </div>
          
          <h1 className="text-4xl font-semibold text-foreground mb-4">
            Create Your Employer Account
          </h1>
          
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto mb-6">
            Join hundreds of companies using Workfolio to find talented candidates through our anonymous, skills-first recruitment platform.
          </p>

          <div className="flex items-center justify-center space-x-6 text-sm text-muted-foreground">
            <div className="flex items-center space-x-2">
              <Icon name="Check" size={16} className="text-success" />
              <span>Free to search candidates</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Check" size={16} className="text-success" />
              <span>Pay only when you unlock</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Check" size={16} className="text-success" />
              <span>GDPR compliant</span>
            </div>
          </div>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Main Registration Form */}
          <div className="lg:col-span-2">
            <div className="bg-card rounded-2xl p-8 border border-border shadow-elevation">
              <div className="mb-8">
                <h2 className="text-2xl font-semibold text-foreground mb-2">
                  Company Registration
                </h2>
                <p className="text-muted-foreground">
                  Fill in your company details to get started with candidate search
                </p>
              </div>

              {/* OAuth Options */}
              <div className="mb-8">
                <OAuthOptions />
              </div>

              {/* Registration Form */}
              <RegistrationForm />
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-8">
            {/* Pricing Information */}
            <PricingInfo />
            
            {/* Trust Signals */}
            <TrustSignals />
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-primary/5 to-accent/5 rounded-2xl p-8 border border-primary/10">
            <h3 className="text-xl font-semibold text-foreground mb-2">
              Already have an account?
            </h3>
            <p className="text-muted-foreground mb-4">
              Sign in to access your employer dashboard and saved searches
            </p>
            <Link
              to="/employer-dashboard"
              className="inline-flex items-center space-x-2 text-primary hover:text-primary/80 font-medium transition-colors"
            >
              <span>Sign in to your account</span>
              <Icon name="ArrowRight" size={16} />
            </Link>
          </div>
        </div>

        {/* Help Section */}
        <div className="mt-12 text-center">
          <p className="text-muted-foreground mb-4">
            Need help with registration?
          </p>
          <div className="flex items-center justify-center space-x-6">
            <Link
              to="/contact"
              className="flex items-center space-x-2 text-primary hover:text-primary/80 transition-colors"
            >
              <Icon name="MessageCircle" size={16} />
              <span>Contact Support</span>
            </Link>
            <span className="text-muted-foreground">•</span>
            <a
              href="mailto:support@workfolio.no"
              className="flex items-center space-x-2 text-primary hover:text-primary/80 transition-colors"
            >
              <Icon name="Mail" size={16} />
              <span>support@workfolio.no</span>
            </a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default EmployerRegistration;